<template>
<div class="google-sso-button-wrap">
  <div v-if="googleClientId && !isAuthenticated" class="google-sso-button" />
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  name: "GoogleSSOButton",
  props: {
    businesslocation: {
      type: String,
      default: null
    },
    preferredlanguage: {
      type: String,
      default: 'en'
    }
  },
  data () {
    return {
      callbackData: null,
      buttonOptions: { 
        size: 'large',
        type: 'standard',
        shape: 'pill',
        logo_alignment: 'center'
      }
    }
  },
  computed: {
    ...mapGetters({
      getGoogleCallbackData: "auth/getGoogleCallbackData",
      isAuthenticated: "auth/getAuthenticated",
    }),
    googleClientId () {
      return process.env.VUE_APP_GOOGLE_CLIENT_ID
    }
  },
  mounted () {
    if (this.googleClientId) {
      this.setupData()
      window.addEventListener('resize', this.renderButton);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.renderButton);
  },
  methods: {
    ...mapActions({ 
      processGoogleCredentials: "auth/processGoogleCredentials"
    }),
    setupData () {
      if (!window.google) {  
        const script = document.createElement('script')  
        script.src = 'https://accounts.google.com/gsi/client'  
        script.async = true  
        script.onload = () => this.onGoogleScriptLoaded()  
        document.head.appendChild(script)  
      } else {  
        this.onGoogleScriptLoaded()  
      }
    },
    onGoogleScriptLoaded () {
      if (!this.isAuthenticated) {
        window.google.accounts.id.initialize({
          client_id: this.googleClientId,
          callback: this.googleSSOCallback
        })
        this.renderButton()
        window.googleSSOCallback = this.googleSSOCallback
        window.google.accounts.id.prompt(); // also display the One Tap dialog
      }
    },
    renderButton () {
      let btn_width = "375"
      if (window.innerWidth < 576) {
        btn_width = "250"
      } else if (window.innerWidth < 768) {
        btn_width = "400"
      } else {
        btn_width = "375"
      }
      this.buttonOptions.width = btn_width
      window.google.accounts.id.renderButton(document.querySelector('.google-sso-button'), this.buttonOptions)
    },
    googleSSOCallback (data) {
      const callbackData = data
      callbackData.country = this.businesslocation
      callbackData.preferred_language = this.preferredlanguage
      this.processGoogleCredentials(callbackData).then(() => {
        this.$emit('authenticatedWithGoogle', true)
      }).catch((error) => {
        if (error.status === 428) {
          this.$emit('country-not-set', false)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.google-sso-button-wrap {
  width: 100%;
  text-align: center;
  .google-sso-button {
    display: inline-block;
  }
}
</style>